import React from "react";
import { clients, clientsHeading } from "../data/site";
import Marquee from "./Marquee";
import Reveal from "./Reveal";
import SectionLabel from "./SectionLabel";
import { cx, display, inner } from "../lib/ui";

export default function Clients() {
  return (
    <div className="pb-section pt-[clamp(56px,9vw,130px)]">
      <div className={cx(inner, "px-gutter")}>
        <Reveal className="grid gap-3 pb-[clamp(26px,3.4vw,44px)] lg:grid-cols-[200px_1fr] lg:items-start lg:gap-[clamp(24px,4vw,60px)]">
          <SectionLabel>{clientsHeading.eyebrow}</SectionLabel>
          <p
            className={cx(
              display,
              "max-w-[16ch] text-[clamp(26px,3.6vw,52px)] leading-[1.05] text-ink"
            )}
          >
            {clientsHeading.headline}
          </p>
        </Reveal>
      </div>

      {/* The roster runs as one continuous line before it settles into the wall. */}
      <Reveal className="border-y border-black/10 py-[clamp(14px,1.8vw,22px)] font-display text-[clamp(24px,4.4vw,60px)] leading-[1.1] text-ink">
        <Marquee items={clients.map((c) => c.name)} speed={58} separator="—" />
      </Reveal>

      <div className={cx(inner, "px-gutter")}>
        <ul className="mt-[clamp(34px,5vw,68px)] grid grid-cols-2 border-l border-t border-black/10 sm:grid-cols-3 lg:grid-cols-4">
          {clients.map((client, i) => (
            <Reveal
              as="li"
              key={client.id}
              delay={Math.min(i, 11) * 45}
              className="group relative flex min-h-[104px] items-center justify-center overflow-hidden border-b border-r border-black/10 px-4 py-[clamp(22px,2.6vw,34px)] text-center text-ink hover:text-paper"
            >
              {/* Ink sweeps up from the floor of the tile. */}
              <span className="absolute inset-0 origin-bottom scale-y-0 bg-ink transition-transform duration-[550ms] ease-smooth group-hover:scale-y-100" />

              {client.logo ? (
                <img
                  src={client.logo}
                  alt={client.name}
                  loading="lazy"
                  className="relative z-10 h-auto w-[clamp(96px,12vw,150px)] opacity-80 grayscale transition duration-[400ms] group-hover:opacity-100 group-hover:invert"
                />
              ) : (
                <span
                  className={cx(
                    display,
                    "relative z-10 text-[clamp(16px,1.6vw,23px)] leading-tight tracking-[-0.01em] transition-colors duration-[400ms] ease-out"
                  )}
                >
                  {client.name}
                </span>
              )}
            </Reveal>
          ))}

          <Reveal
            as="li"
            delay={540}
            className="flex min-h-[104px] items-center justify-center border-b border-r border-black/10 px-4 py-[clamp(22px,2.6vw,34px)] text-center"
          >
            <span
              className={cx(
                display,
                "text-[clamp(16px,1.6vw,23px)] italic leading-tight text-ash-300"
              )}
            >
              {clientsHeading.footnote}
            </span>
          </Reveal>
        </ul>
      </div>
    </div>
  );
}
